<template>
	<div class="invite-full">
		<ProfilePic :user="invite.organization" class="org-logo" size="100px" />

		<div class="message">
			<i18n-t keypath="groupinvites_signup_join_org_label" tag="div">
				<template #GroupName>
					<strong>{{ invite.group.title }}</strong>
				</template>
				<template #OrgName>
					<strong>{{ invite.organization.name }}</strong>
				</template>
			</i18n-t>

			<p v-t="'groupinvites_error_member_max'" />
		</div>

		<Button pronto link :to="signin">
			{{
				$t('groupinvites_org_member_already', {
					OrgName: invite.organization.name,
				})
			}}
		</Button>
	</div>
</template>

<script>
import { ProfilePic, Button } from '@/components/common'
import { getInvite, signinRoute } from './index'
export default {
	name: 'InviteFull',
	components: { ProfilePic, Button },
	data() {
		return { invite: getInvite() }
	},
	computed: {
		signin() {
			return { name: signinRoute.name, params: this.$route.params }
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.invite-full {
	@include flex-column-center;

	.org-logo {
		margin-top: 100px;
		margin-bottom: 13px;
	}

	.message {
		font-size: 18px;
		text-align: center;
		margin: 10px 85px 0;
		min-height: 220px;
		@include fontFamily(400);

		p {
			margin-top: 50px;
		}

		strong {
			font-family: map-get($fonts, 800);
		}
	}
}
</style>
